import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const MIRAMARWATERSTORAGE_LAYER_ID = 'miramarWaterStorageLayer';

const layerConfig = {
  title: 'Water Storage',
};

function MiramarWaterStorageLayer() {
  const dispatch = useDispatch();
  const { miramarWaterStorageLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarWaterStorageLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarWaterStorageLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARWATERSTORAGE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarWaterStorageLayer.visible,
      opacity: miramarWaterStorageLayer.opacity,

      getFillColor: [0, 134, 149],
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARWATERSTORAGE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['Water_Storage_Name', 'Storage_Capacity_MG'],
            }),
          };
        }
      },
    });
  }
}

export default MiramarWaterStorageLayer;
